<template lang="html">
  <div class="">
    <vs-row class="cerca">
      <vs-col vs-w="10" vs-sm="12">
        <vx-input-group class="mb-base">
          <vx-tooltip :text="'Puoi cercare per: Cognome, Nome'" position="left">
            <vs-input v-model="v_keyword" icon-pack="feather" icon="icon-search" label-placeholder="Cerca" class="is-label-placeholder w-full" icon-no-border></vs-input>
          </vx-tooltip>
        </vx-input-group>
      </vs-col>
      <vs-col vs-w="2" vs-sm="12">
        <vs-button @click="new_form_open = true" color="success" type="line" icon-pack="feather" icon="icon-plus" icon-after>Nuovo</vs-button>
      </vs-col>
    </vs-row>

    <TabellaTutor :tutor="tutor || []"/>

    <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-pacchetti" spacer v-model="new_form_open">
      <TutorForm @close-me="sidebarClose" v-if="new_form_open" @saved="new_form_open = false; refreshTutor()"/>
    </vs-sidebar>
  </div>
</template>

<script>
import TabellaTutor from './TabellaTutor'
import TutorForm from './TutorForm'
export default {
  components: {
    TabellaTutor,
    TutorForm,
  },

  data () {
    return {
      tutor: null,
      params: {},
      new_form_open: false,
      v_keyword: ''
    }
  },

  created () {
    this.refreshTutor()
  },

  computed: {
    // new_form_open: {
    //   get () { return !!this.new_form },
    //   set (v) { if (!v) this.new_form = null }
    // },
  },

  methods: {
    refreshTutor () {
      this.$vs.loading({
        type:'radius',
      })
      axios.post(process.env.VUE_APP_BACKEND_API+'/tirocinio/manytutor', {
        keyword: this.v_keyword,
      },{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      })
      .then(response => {
        if (response.data.length == 0) {  this.tutor = []  }
        else {
          this.tutor = response.data
        }
        this.$vs.loading.close()
      })
      .catch(e => {
        console.log(e)
        this.$vs.loading.close()
      })
      // this.$http.get('tirocinio/tutor').then(res => {
      //   this.tutor = res.data
      // })
    },
    sidebarClose() {
      // this.selected = null
      this.new_form_open = false
    }
  },
  watch: {
    v_keyword() {
      if (this.v_keyword.length > 2 || this.v_keyword.length == 0) {
        this.refreshTutor()
      }
    }
  },

}
</script>
